/*
 * File: DashboardCardNumber.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Renders out the count for the dasboard card
 */
import React from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, Typography } from "@material-ui/core";

const size = "2em";
const useStyles = makeStyles({
  numTitle: {
    marginRight: 8,
    marginLeft: 8,
    fontWeight: 100,
    fontSize: size
  },
  progress: {
    margin: 8
  }
});

const DashboardCardNumber = ({ loading, number }) => {
  const classes = useStyles();
  if (loading) {
    return (
      <div className={classes.progress}>
        <CircularProgress size={size} />
      </div>
    );
  } else {
    return (
      <Typography color="primary" className={classes.numTitle}>
        {number}
      </Typography>
    );
  }
};

DashboardCardNumber.propTypes = {
  loading: PropTypes.bool,
  number: PropTypes.number
};

export default DashboardCardNumber;
